var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7709 7.71551C12.7709 8.99543 11.6136 9.92133 11.2459 10.2073C10.4971 10.7927 10.4834 11.2012 10.4834 11.9093C10.4834 12.168 10.3473 12.4675 9.68008 12.4675C9.1218 12.4675 8.93121 12.2632 8.93121 11.5552C8.93121 10.3843 9.44863 9.82598 9.84348 9.48559C10.2928 9.10434 11.0553 8.68227 11.0553 7.94695C11.0553 7.32063 10.5107 7.02105 9.82984 7.02105C8.44102 7.02105 8.74055 8.06949 8.00531 8.06949C7.63766 8.06949 7.18836 7.82441 7.18836 7.29336C7.18836 6.55809 8.03254 5.46883 9.8707 5.46883C11.6136 5.46883 12.7709 6.43559 12.7709 7.71551ZM10.7421 14.4555C10.7421 15.0138 10.2791 15.5039 9.69367 15.5039C9.1082 15.5039 8.65887 15.0137 8.65887 14.4555C8.65887 13.8836 9.12184 13.407 9.69367 13.407C10.2656 13.407 10.7421 13.8836 10.7421 14.4555ZM10 18.4375H1.5625V10C1.5625 5.33684 5.33621 1.5625 10 1.5625C14.6632 1.5625 18.4375 5.33621 18.4375 10C18.4375 14.6632 14.6638 18.4375 10 18.4375ZM10 0C4.47328 0 0 4.47254 0 10V19.2188C0 19.6502 0.349766 20 0.78125 20H10C15.5267 20 20 15.5275 20 10C20 4.47328 15.5275 0 10 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.7c5fde14.svg";
export { ForwardRef as ReactComponent };